// uid: BWR-FIN_STMT_YTD_Q1-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2247
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsExpressLoan,
  IsBetweenMidMayMidAug,
  IsForProfit,
  IsBetweenJanAndMidFeb,
  IsBetweenMidFebMidApril,
  IsBetweenMidAprilMidMay,
} from '../rules';
import IsFBO from '../rules/IsFBO';
import IsBusinessEstablishedLessThan from '../rules/IsBusinessEstablishedLessThan';
import FinancialStatementQ2Ruleset from './FinancialStatementQ2Ruleset';
import FinancialStatementQ3Ruleset from './FinancialStatementQ3Ruleset';

class FinancialStatementQ1Ruleset implements Ruleset {
  private forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const isExpress = IsExpressLoan.evaluate(data);
    const isBetweenMidMayMidAug = IsBetweenMidMayMidAug.evaluate(data);
    const establishedLessThanThreeYearsAgo =
      IsBusinessEstablishedLessThan.setYears(3).evaluate(data);
    const isBetweenJanAndMidMay = [
      IsBetweenJanAndMidFeb,
      IsBetweenMidFebMidApril,
      IsBetweenMidAprilMidMay,
    ].some((Is) => Is.evaluate(data));

    // A) Is Express && Between Mid May and Mid Aug && Established Less Than Three Years Ago
    // B) Is Core && Express Plus, Industry PG or PPA (meaning Not Express), &&
    // - Between Mid May and Mid Aug : REQUIRED
    // - Between Jan and Mid May : OPTIONAL
    if (isBetweenMidMayMidAug) {
      if ((isExpress && establishedLessThanThreeYearsAgo) || !isExpress) {
        return RulesetResult.REQUIRED;
      }
    }
    if (!isExpress && isBetweenJanAndMidMay) {
      return RulesetResult.OPTIONAL;
    }
    return RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    // A later year-to-date statement already includes this quarter.
    const laterYearToDateStatementIsRequested =
      FinancialStatementQ2Ruleset.evaluate(data) !== RulesetResult.HIDDEN ||
      FinancialStatementQ3Ruleset.evaluate(data) !== RulesetResult.HIDDEN;
    if (laterYearToDateStatementIsRequested) return RulesetResult.HIDDEN;

    if (IsFBO.evaluate(data)) return RulesetResult.REQUIRED;
    const isForProfit = IsForProfit.evaluate(data);

    // If For Profit
    if (isForProfit) return this.forProfitResult(data);

    // If Not For Profit
    const isBetweenMidMayMidAug = IsBetweenMidMayMidAug.evaluate(data);
    const isBetweenJanAndMidMay = [
      IsBetweenJanAndMidFeb,
      IsBetweenMidFebMidApril,
      IsBetweenMidAprilMidMay,
    ].some((Is) => Is.evaluate(data));

    if (isBetweenMidMayMidAug) {
      return RulesetResult.REQUIRED;
    }
    if (isBetweenJanAndMidMay) {
      return RulesetResult.OPTIONAL;
    }

    return RulesetResult.HIDDEN;
  };
}

export default new FinancialStatementQ1Ruleset();
